import React, { useEffect, useMemo, useState } from "react";

import school from "../../assets/mycenter.jpg";
import { IoIosMail } from "react-icons/io";
import { useRequestProcessor } from "../../requestProcessor";
import { useAtom } from "jotai";
import {
  activeChildDetail,
  appConstants,
  ChildTimeLineAtom,
  parentProfile,
  userstate,
} from "../../AtomStore/store";
import { useNavigate } from "react-router-dom";
import { ReloadData, resetDoorPin } from "../../QueryFunctions/queryfunction";

import moment from "moment";
import SpinnerLoading from "../../Components/utils/SpinnerLoading";
import { FaSyncAlt } from "react-icons/fa";
import "./RefreshButton.css";
import profile from "../../Pages/components/assets/pictures/profile.png";

const Profile = () => {
  const { useMutationWrapper } = useRequestProcessor();
  const DEFAULT_FORMAT = "MMM DD, YYYY";
  const [user] = useAtom(userstate);
  const [activeChild] = useAtom(activeChildDetail);
  const [parent] = useAtom(parentProfile);
  const [constants] = useAtom(appConstants);
  const [childTimeline] = useAtom(ChildTimeLineAtom);

  const [, setImgSrc] = useState();

  const navigate = useNavigate();

  console.log("childtimelinedata", childTimeline);

  console.log("Active child", activeChild);
  useMemo(() => {
    console.log(
      `[My Profile] Fetching My Profile details of user: ${activeChild?.id}`
    );
    // console.log(`[My Profile] Fetched Parents profile: ${parent?.parentPhoto}`);

    setImgSrc("");
  }, [activeChild]);

  // const updateUserEmail = useMutationWrapper('updateUserEmail', () =>
  //   updateUserEmailMutationFunction(activeChild, parent)
  // );

  const resetPin = useMutationWrapper("resetDoorPin", () => resetDoorPin());
  const getFullPath = (constants, path) => {
    let imgString = "";
    if (typeof path === "string" && path.startsWith("https")) {
      imgString = path;
    } else if (typeof path === "string" && path.length === 0) {
      imgString = path;
    } else {
      imgString = constants?.ImagePath + path;
    }

    // console.log("Path logged from the getFullPath function",imgString);

    return imgString;
  };

  const reloadData = useMutationWrapper(
    "reload",
    () => {
      console.log(
        "[My Profile] Calling API: /parentapp/childLoginReloadDetails ",
        activeChild,
        { child_id: activeChild?.id }
      );

      return ReloadData(navigate);
    },
    {
      onSuccess: (data) => {
        console.log("[My Profile] Reload child data response:", data);
      },
    }
  );

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);
  const handleImageError = (e) => {
    e.target.src = profile;
  };

  // const handleError = () => {
  //   setImgSrc(require('../../assets/demoImg.png'));
  // };

  return (
    <div className="">
      <div className=" overflow-x-hidden bg-white ">
        {resetPin.isLoading || reloadData.isLoading ? <SpinnerLoading /> : ""}
        <img
          src={school}
          className="h-32 w-full object-cover lg:h-40"
          alt="school"
        />
        <div className="grid grid-cols-12 gap-2 mt-[-60px]  rounded-2xl p-3 bg-transparent">
          <div className="col-span-4  flex items-center justify-center">
            {activeChild?.child_photo &&
              activeChild?.child_approved_status !== "Inactive" && (
                <img
                  className="relative border-solid border-3 border-blue-300 rounded-full  size-28 xl:size-36 lg:-mt-10 xl:-ml-40 lg:border-white lg: border-5 lg:size-30 lg:-ml-30 object-cover"
                  src={getFullPath(constants, activeChild?.child_photo)}
                  alt="child"
                  onError={handleImageError}
                ></img>
              )}

            {
              <p
                className="text-center"
                style={{
                  color: "red",
                  fontSize: 12,
                }}
              >
                {activeChild?.child_approved_status === "Active"
                  ? ""
                  : activeChild?.child_approved_status}
              </p>
            }
          </div>

          <div className="col-span-6 mt-5 xl:bg-white lg:p-4 xl:rounded-3xl xl:-ml-44 lg:-ml-34">
            <h3 className="text-normal sm:text-lg font-bold ml-2 xl:text-3xl lg:text-2xl">
              {activeChild?.name + " " + activeChild?.last_name} &nbsp;{" "}
              <span className="text-xs font-medium text-gray lg:-ml-2">
                {activeChild?.id}
              </span>
            </h3>
            <ul className="list-none text-sm font-medium text-gray lg:-ml-1">
              <li className="mt-1">
                {" "}
                <i className="icon-birthday text-header text-xl lg:p-2"></i>
                {moment(activeChild?.date_of_birth).format(DEFAULT_FORMAT)}
              </li>
            </ul>
          </div>

          <div className="col-span-2 flex pt-4 lg:ml-12">
            <button
              onClick={reloadData.mutate}
              className="refresh-button"
              disabled={reloadData.isLoading}
            >
              <FaSyncAlt
                className={`refresh-icon text-header size-7 ${
                  reloadData.isLoading ? "spinning" : ""
                }`}
              />
            </button>
          </div>
        </div>

        {/* <ul className="mx-3 border-2 p-2 rounded-sm lg:mt-2 md:hidden">
          <li className="mt-1 lg:p-2">
            {" "}
            <i className="icon-class  text-header text-xl lg:p-2"></i>
            {activeChild?.["room.name"]} ({activeChild?.["length"]})
          </li>
          <li className="mt-1 lg:p-2">
            {" "}
            <i className="icon-admission  text-header text-xl lg:p-2"></i>
            {activeChild?.["admission_center_name.name"]}
          </li>
        </ul> */}
        {/* <div className="grid grid-cols-12 gap-2  justify-between mx-3 mt-2">
        <div className="col-span-6 flex gap-2  items-center justify-center border-2 rounded-2xl p-4 bg-gradient-to-r from-cyan-100 to-sky-400">
          <h4 className="text-lg mt-2 leading-4">
            62.02 <span className="font-semibold text-sm">cm</span>
          </h4>

          <img className="size-10" alt="frog" src={height}></img>
        </div>
        <div className="col-span-6 flex gap-2 items-center justify-center border-2 rounded-2xl p-4 bg-gradient-to-r from-cyan-100 to-sky-400">
          <h4 className="text-lg mt-2 leading-4">
            22.04 <span className="font-semibold text-sm">kg</span>
          </h4>

          <img className="size-10" alt="frog" src={scale}></img>
        </div>
      </div> */}

        {/* parent information div */}
        {/* <div className="grid grid-cols-12 gap-2 bg-white rounded-2xl p-3 hidden">
          <h3 className="text-lg font-bold text-dark col-span-12 lg:text-xl lg:m-4">
            Parent Information
          </h3>
          <div className="col-span-3 flex items-center justify-center">
            {parent?.parentPhoto &&
              parent?.parentApprovedStatus !== "Inactive" && (
                <img
                  style={{ border: "3px solid #47aee4" }}
                  className="rounded-full size-20 lg:m-4"
                  src={getFullPath(constants, parent?.parentPhoto)}
                  alt="parent"
                  onError={handleImageError}
                ></img>
              )}
          </div>

          <div className="col-span-9 lg:mt-4 lg:-ml-10">
            <h3 className="text-md font-bold">{parent?.parentName} </h3>
            <ul className="list-none text-sm font-semibold text-gray ">
              <li className="mt-1">
                {" "}
                <i className="icon-email  text-header text-sm"></i>
                {parent?.parentType.toLowerCase() === "mother"
                  ? parent?.motherEmail
                  : parent?.fatherEmail}
              </li>
              <li className="mt-1">
                {" "}
                <i className="icon-phone  text-header text-sm"></i>
                {parent?.parentPhone}
              </li>
            </ul>
          </div>
        </div> */}

        {/* reload button div */}
        {/* <div className="grid grid-cols-12 gap-2 mt-2 rounded-2xl bg-white mx-3 border-2 p-2 xl:w-[800px] hidden">
          <div className="col-span-2 flex items-center justify-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="size-8 text-header"
            >
              <path
                fillRule="evenodd"
                d="M15.75 1.5a6.75 6.75 0 0 0-6.651 7.906c.067.39-.032.717-.221.906l-6.5 6.499a3 3 0 0 0-.878 2.121v2.818c0 .414.336.75.75.75H6a.75.75 0 0 0 .75-.75v-1.5h1.5A.75.75 0 0 0 9 19.5V18h1.5a.75.75 0 0 0 .53-.22l2.658-2.658c.19-.189.517-.288.906-.22A6.75 6.75 0 1 0 15.75 1.5Zm0 3a.75.75 0 0 0 0 1.5A2.25 2.25 0 0 1 18 8.25a.75.75 0 0 0 1.5 0 3.75 3.75 0 0 0-3.75-3.75Z"
                clipRule="evenodd"
              />
            </svg>
          </div>

          <p className=" col-span-5 flex text-2xl text-center tracking-[10px] items-center xl:-ml-8">
            {user?.password}
          </p>
          <button
            onClick={(e) => {
              e.preventDefault();
              resetPin.mutate();
            }}
            className=" col-span-5 py-1 w-full bg-header text-lg font-semibold text-white rounded-lg "
          >
            Re-Generate
          </button>
        </div> */}
      </div>

      {/* my custom design */}

      <div class="grid grid-cols-12 gap-6 items-center justify-center w-full max-w-full mx-auto p-2 md:mt-4 mb-4">
        {resetPin.isLoading || reloadData.isLoading ? <SpinnerLoading /> : ""}

        <div class=" col-span-12 lg:col-span-6 h-full bg-white rounded-lg xl:shadow-md border w-full">
          <h3 class="text-lg font-semibold text-white p-3 rounded-md bg-[#19ade4]">
            Child Information
          </h3>
          <div className="p-2 md:p-5">
            {/* <div class="flex flex-col items-center mt-4">
                  <p class="text-gray-700 font-bold text-lg mt-2"> {activeChild?.name + ' ' + activeChild?.last_name} </p>
                  <p class="text-gray-500 text-sm pb-[60px]">{activeChild?.['admission_center_name.name']}</p>
              </div> */}
            <div class="mt-2 space-y-2">
              {/* <div class="flex items-center justify-between bg-gray-100 pl-2 rounded-md">
                      <span class="flex items-center">Reload Child</span>
                      <button onClick={reloadData.mutate} className="refresh-button" disabled={reloadData.isLoading}>
                          <FaSyncAlt className={`refresh-icon text-header size-9 p-2 ${reloadData.isLoading ? 'spinning' : ''}`} />
                      </button>
                  </div> */}

              <div class="items-center justify-between bg-gray-100 p-2 rounded-md grid grid-cols-12">
                <span class="flex items-center col-span-5">📚 Class</span>
                <span className=" col-span-1 text-right">:</span>
                <span class="font-semibold col-span-6 flex justify-start break-all ml-1">
                  {activeChild?.["room.name"]} ({activeChild?.["length"]})
                </span>
              </div>

              <div class="items-center justify-between bg-gray-100 p-2 rounded-md grid grid-cols-12 ">
                <span class="flex items-center col-span-5">🏛️ Center</span>
                <span className="col-span-1 text-right">:</span>

                <span class="font-semibold col-span-6 flex justify-start break-all ml-1">
                  {activeChild?.["admission_center_name.name"]}
                </span>
              </div>

              {/* <div class="items-center justify-between bg-gray-100 p-2 rounded-md grid grid-cols-12">
                <span class="flex items-center col-span-5">🎂 DOB</span>
                <span className="col-span-1 text-right">:</span>

                <span class="flex font-semibold col-span-6 justify-start">
                  &nbsp;{" "}
                  {moment(activeChild?.date_of_birth).format(DEFAULT_FORMAT)}
                </span>
              </div> */}

              <div class="items-center justify-between bg-gray-100 p-2 rounded-md grid grid-cols-12">
                <span class="flex items-center col-span-5">🩸 Blood Group</span>
                <span className="col-span-1 text-right">:</span>

                <span class="font-semibold col-span-6 flex justify-start">
                  &nbsp; {activeChild?.blood_group}
                </span>
              </div>
            </div>
          </div>

          <div className=" flex justify-center p-2 md:p-5">
            <div className="grid grid-cols-12 gap-2 mt-2 rounded-2xl bg-white mx-3 border-2 p-2 ">
              <div className="col-span-2 flex items-center justify-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="size-8 text-header"
                >
                  <path
                    fillRule="evenodd"
                    d="M15.75 1.5a6.75 6.75 0 0 0-6.651 7.906c.067.39-.032.717-.221.906l-6.5 6.499a3 3 0 0 0-.878 2.121v2.818c0 .414.336.75.75.75H6a.75.75 0 0 0 .75-.75v-1.5h1.5A.75.75 0 0 0 9 19.5V18h1.5a.75.75 0 0 0 .53-.22l2.658-2.658c.19-.189.517-.288.906-.22A6.75 6.75 0 1 0 15.75 1.5Zm0 3a.75.75 0 0 0 0 1.5A2.25 2.25 0 0 1 18 8.25a.75.75 0 0 0 1.5 0 3.75 3.75 0 0 0-3.75-3.75Z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>

              <p className=" col-span-5 flex text-2xl text-center  tracking-[3px] sm:tracking-[5px] md:tracking-[10px]  items-center">
                {user?.password}
              </p>
              <button
                onClick={(e) => {
                  e.preventDefault();
                  resetPin.mutate();
                }}
                className=" col-span-5 py-1 w-full bg-header text-sm  md:text-base  font-semibold text-white rounded-lg px-2 "
              >
                Re-Generate
              </button>
            </div>
          </div>
        </div>

        <div class="col-span-12 lg:col-span-6 h-full bg-white rounded-lg xl:shadow-md border w-full">
          <h3 class="text-lg font-semibold text-white p-3 rounded-md bg-[#19ade4]">
            Parent Information
          </h3>
          <div className=" p-2 md:p-5 lg:p-4 grid grid-cols-12 gap-2">
            <div class="col-span-4 md:col-span-12 flex flex-col items-center mt-4">
              {parent?.parentPhoto &&
                parent?.parentApprovedStatus !== "Inactive" && (
                  <img
                    style={{ border: "3px solid #47aee4" }}
                    className="w-26 h-26 md:w-36 md:h-36 rounded-full border-4 border-blue-500 object-cover"
                    src={getFullPath(constants, parent?.parentPhoto)}
                    alt="parent"
                    onError={handleImageError}
                  />
                )}
              <p class="text-gray-700 font-medium mt-2 text-center">
                {parent?.parentType}
              </p>
            </div>
            <div class="mt-2 md:mt-2  space-y-2 col-span-8 md:col-span-12">
              <div class="flex items-center bg-gray-100 p-2 rounded-md">
                <span class="mr-2">👤</span>
                <input
                  type="text"
                  value={parent?.parentName}
                  class="bg-transparent w-full outline-none"
                  disabled
                />
              </div>

              <div class="flex items-center bg-gray-100 p-2 rounded-md">
                <span class="mr-2 text-xl flex items-center">
                  {" "}
                  <IoIosMail />{" "}
                </span>
                <input
                  type="text"
                  value={
                    parent?.parentType.toLowerCase() === "mother"
                      ? parent?.motherEmail
                      : parent?.fatherEmail
                  }
                  class="bg-transparent w-full outline-none"
                  disabled
                />
              </div>

              <div class="flex items-center bg-gray-100 p-2 rounded-md">
                <span class="mr-2">📞</span>
                <input
                  type="text"
                  value={parent?.parentPhone}
                  class="bg-transparent w-full outline-none"
                  disabled
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
